import { render, staticRenderFns } from "./ProductFormRequest.vue?vue&type=template&id=0872a2f4&scoped=true"
import script from "./ProductFormRequest.vue?vue&type=script&lang=js"
export * from "./ProductFormRequest.vue?vue&type=script&lang=js"
import style0 from "./ProductFormRequest.vue?vue&type=style&index=0&id=0872a2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0872a2f4",
  null
  
)

export default component.exports